import React from 'react';

// Skip to main content component for accessibility
export const SkipToMainContent: React.FC = () => {
  return (
    <a 
      href="#main-content" 
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-arctic-blue text-white px-4 py-2 rounded-md z-50"
    >
      Skip to main content
    </a>
  );
};

// Apply focus visible polyfill for better keyboard navigation
export const applyFocusVisiblePolyfill = () => {
  // This is a simple implementation - in production, you might use a proper polyfill
  if (!document.body.classList.contains('focus-visible-applied')) {
    document.body.classList.add('focus-visible-applied');
    
    // Add keyboard navigation detection
    let hadKeyboardEvent = false;
    
    const keydownHandler = () => {
      hadKeyboardEvent = true;
    };
    
    const mousedownHandler = () => {
      hadKeyboardEvent = false;
    };
    
    const focusHandler = (e: FocusEvent) => {
      if (hadKeyboardEvent && e.target instanceof HTMLElement) {
        e.target.classList.add('focus-visible');
      }
    };
    
    const blurHandler = (e: FocusEvent) => {
      if (e.target instanceof HTMLElement) {
        e.target.classList.remove('focus-visible');
      }
    };
    
    document.addEventListener('keydown', keydownHandler, true);
    document.addEventListener('mousedown', mousedownHandler, true);
    document.addEventListener('focus', focusHandler, true);
    document.addEventListener('blur', blurHandler, true);
  }
};